(function () {
  if (window.fpHomeCtaTrackingReady) return;
  window.fpHomeCtaTrackingReady = true;

  var storageKey = 'fp_home_cta_variant';
  var variant = null;

  function allowed(method) {
    var privacy = window.Shopify && window.Shopify.customerPrivacy;
    return Boolean(privacy && typeof privacy[method] === 'function' && privacy[method]() === true);
  }

  if (document.querySelector('.fp-home-v1') && allowed('preferencesProcessingAllowed')) {
    try {
      variant = window.localStorage.getItem(storageKey);
      if (!variant) {
        variant = Math.random() < 0.5 ? 'A' : 'B';
        window.localStorage.setItem(storageKey, variant);
      }
    } catch (error) {
      variant = 'A';
    }
    document.documentElement.setAttribute('data-fp-home-cta-variant', variant);
  }

  function pushEvent(payload) {
    if (!allowed('analyticsProcessingAllowed')) return;
    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push(payload);
  }

  document.addEventListener('click', function (event) {
    var target = event.target instanceof Element && event.target.closest('[data-fp-home-cta]');
    if (!target) return;
    var isFooter = target.getAttribute('data-fp-home-section') === 'footer';

    pushEvent({
      event: isFooter ? 'fp_footer_cta_click' : 'fp_home_cta_click',
      cta_id: target.getAttribute('data-fp-home-cta') || '',
      cta_label: target.getAttribute('aria-label') || (target.textContent || '').trim(),
      cta_section: target.getAttribute('data-fp-home-section') || '',
      cta_destination: target.getAttribute('href') || '',
      cta_variant: isFooter ? null : variant,
      page_path: window.location.pathname
    });
  });
})();
